import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, ChevronRight } from 'lucide-react'

const Breadcrumb = ({ 
  items = [], 
  className = '', 
  showIcons = false,
  /** Optional slot rendered at the right end of the breadcrumb line (e.g. help icon) */
  rightSlot = null,
  /** Set to false to hide the back arrow (navigation via breadcrumb links only) */
  showBackButton = true 
}) => {
  const navigate = useNavigate()

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick()
    } else if (item.path) {
      navigate(item.path)
    }
  }

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <div className={`breadcrumb-section ${rightSlot ? 'breadcrumb-section-with-right' : ''} ${!showBackButton ? 'breadcrumb-section-no-back' : ''} ${className}`}>
      <nav className="breadcrumb-nav" aria-label="Breadcrumb">
        {showBackButton && (
          <button 
            type="button"
            className="breadcrumb-back-btn"
            onClick={handleBack}
            title="Go back"
            aria-label="Go back"
          >
            <ArrowLeft size={16} strokeWidth={2} />
          </button>
        )}
        <ol className="breadcrumb-items">
          {items.map((item, index) => (
            <li key={index} className="breadcrumb-crumb">
              {index > 0 && (
                <ChevronRight className="breadcrumb-separator" size={14} strokeWidth={2} aria-hidden="true" />
              )}
              {item.isCurrent ? (
                <span className="breadcrumb-current" aria-current="page">
                  {item.label}
                </span>
              ) : (
                <button 
                  type="button"
                  className="breadcrumb-item"
                  onClick={() => handleItemClick(item)}
                  disabled={item.disabled}
                >
                  {item.label}
                </button>
              )}
            </li>
          ))}
        </ol>
      </nav>
      {rightSlot && <div className="breadcrumb-right-slot">{rightSlot}</div>}
    </div>
  )
}

export default Breadcrumb
